<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ct" id="toc_marker-3"><a id="Contents-A">Contents</a></p><a id="Contents-A">
</a></div><a id="Contents-A">
</a><div><a id="Contents-A">
<p class="ct"></p>
</a><p class="Contents-Entry"><a id="Contents-A"></a><a href="#/This_Isn't_A_Game#toc_marker-1">This Isn’t a Game</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game1#toc_marker-2">Copyright</a></p>
<p class="Contents-Entry"><a href="#/#toc_marker-3">Contents</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game3#toc_marker-4">Dedication</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game4#toc_marker-5">Thursday</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game5#toc_marker-6">Saturday</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game6#toc_marker-7">Monday</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game7#toc_marker-8">Tuesday</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game8#toc_marker-9">Tuesday, 1:43 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game9#toc_marker-10">Tuesday, 2:52 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game10#toc_marker-11">Tuesday, 3:26 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game11#toc_marker-12">Tuesday, 4:32 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game12#toc_marker-13">Tuesday, 5:02 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game13#toc_marker-14">Tuesday, 6:10 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game14#toc_marker-15">Tuesday, 6:45 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game15#toc_marker-16">Wednesday, 7:45 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game16#toc_marker-17">Wednesday, 9:30 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game17#toc_marker-18">Wednesday, 11:45 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game18#toc_marker-19">Wednesday, 1:15 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game19#toc_marker-20">Wednesday, 1:48 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game20#toc_marker-21">Wednesday, 2:59 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game21#toc_marker-22">Wednesday, 3:48 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game22#toc_marker-23">Wednesday, 6:36 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game23#toc_marker-24">Wednesday, 8:19 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game24#toc_marker-25">Wednesday, 9:23 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game25#toc_marker-26">Wednesday, 10:17 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game26#toc_marker-27">Thursday, 5:45 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game27#toc_marker-28">Thursday, 7:03 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game28#toc_marker-29">Thursday, 8:25 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game29#toc_marker-30">Thursday, 9:44 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game30#toc_marker-31">Thursday, 10:02 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game31#toc_marker-32">Thursday, 10:57 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game32#toc_marker-33">Thursday, 11:33 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game33#toc_marker-34">Thursday, 12:36 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game34#toc_marker-35">Thursday, 1:07 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game35#toc_marker-36">Thursday, 1:45 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game36#toc_marker-37">Thursday, 2:33 p.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game37#toc_marker-38">Friday, 6:30 a.m.</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game38#toc_marker-39">Acknowledgments</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game39#toc_marker-40">More from this Author</a></p>
<p class="Contents-Entry"><a href="#/This_Isn't_A_Game40#toc_marker-41">Contact Us</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// This_Isnt_A_Game-2.vue?0adb179a